'use client';

const defaultInputLabel = "Search";
const defaultClearButtonLabel = "Clear search";
export {
  defaultClearButtonLabel,
  defaultInputLabel
};
